import { ApiService, FaqGroup, FaqItem } from '@ebeihilfe/core';
import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { CustomComponentModule } from '../../../components';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NoteComponent } from '@ebeihilfe/web-shared/note';
import { Observable, of } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'portal-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    imports: [
        CustomComponentModule,
        NoteComponent,
        TranslateModule,
        AsyncPipe,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelTitle,
        MatExpansionPanelHeader,
        MatProgressSpinner,
    ]
})
export class HelpComponent {
  public errorMessage = '';
  public faqList$: Observable<FaqGroup[]>;
  public loaded = false;

  constructor(private api: ApiService) {
    this.faqList$ = this.api.restGet<FaqItem[][]>('file/faq').pipe(
      takeUntilDestroyed(),
      map((value) => value.map(this.createFaqGroup, this)),
      catchError((err) => {
        this.errorMessage = err;
        return of([]);
      }),
    );
  }

  public get showError(): boolean {
    return this.errorMessage !== '';
  }

  private createFaqGroup(data: FaqItem[]): FaqGroup {
    return data.length > 0
      ? {
          id: this.removeSpecialChars(data[0].category),
          categoryName: data[0].category,
          faqItems: data.map(this.createFaqItem, this),
        }
      : null;
  }

  private createFaqItem(data: FaqItem): FaqItem {
    return {
      ...data,
      id: this.removeSpecialChars(data.name),
    };
  }

  private removeSpecialChars(text: string): string {
    return text.replace(/\(|\)|\/|\?|\s|\./g, '');
  }
}
